export default __webpack_public_path__ + "static/media/HindiDiwas2.88c37db7.JPG";